import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nome',
})
export class NomePipe implements PipeTransform {

  transform(value:string): string {
    
    let nome = value.split(' ');
    let nomeFormatado = '';

    for(let i = 0; i < nome.length; i++){
      if( i === 0 ){
        nomeFormatado += nome[i];
      }else if( i < nome.length - 1 && i !== 0 && nome[i].length > 2){
        nomeFormatado += " " + nome[i].charAt(0) + ".";
      }else if(nome[i].length> 2){
        nomeFormatado += " " + nome[i];
      }
    }

    return `${nomeFormatado.toLocaleLowerCase()}`;

  }

}
